// @ts-nocheck
import Heading from 'atoms/heading/heading';
import _, { isNumber } from 'lodash';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import * as React from 'react';
import { Switch } from 'antd';
import * as constants from './constants';
import * as queries from './queries';
import { useDispatch, useSelector } from 'react-redux';
import * as sagaActions from './sagaActions';
import NumberInput from 'atoms/NumberInput/numberInput';
import Icon from 'atoms/icons/icon';
import Validation from 'atoms/validation/validation';
import { isParametersWrite } from 'models/user/selector';
import { Typography } from 'antd';
import { formatForUI, parseFromUI } from './constants';

const { Title, Text } = Typography;

type Props = {
	parameter: any;
	selectedTab: string;
	selector: string;
	groupData: Object;
};

const ParameterDetailItem = ({ parameter, selectedTab, selector, groupData }: Props) => {
	const { ParameterTitle, ParameterFormat, IsOn, ParameterDescription } = parameter;
	const [paramValue, updateParamValue] = React.useState(
		ParameterFormat === 'Bit'
			? parameter.UpdatedValue
			: parameter.Detail_Value && isNumber(parameter.Detail_Value)
				? parameter.Detail_Value
				: parameter.Default_Value
	);
	const hasParametersWrite = useSelector(isParametersWrite);
	const dispatch = useDispatch();
	const handleActivateParameter = React.useCallback(
		(updates, isEdit?) => {
			dispatch(
				sagaActions.upsertParameterDetails({
					...updates,
					ParameterTypeID: selectedTab,
					ParameterDetailID: parameter.ParameterDetailID,
					ParameterID: parameter.ParameterID,
					ParameterValue: _.has(updates, 'UpdatedValue')
						? updates.UpdatedValue
						: parameter.Detail_Value || parameter.Default_Value || 0,
					ParameterMasterID: groupData.ParameterMasterID,
					ParameterGroupItemID: groupData[selector],
					ParameterSelector: selector,
				})
			);
		},
		[
			dispatch,
			selectedTab,
			parameter.ParameterDetailID,
			parameter.ParameterID,
			parameter.Detail_Value,
			parameter.Default_Value,
			groupData,
			selector,
		]
		// [dispatch, selectedTab, groupData, updateParamValue, parameter.ParameterDetailID, parameter.ParameterID]
	);

	return (
		<Stack gutter="large" position="center" className="setting-block">
			<Stack className="setting-block-lt">
				{selectedTab !== constants.PARAMETER_TYPES.DEFAULT && (
					<StackItem className="switch-icon">
						{parameter.IsLocked ? (
							// <Icon faAlias="faLock" />
							<i className="icon-lock" />
						) : (
							<Switch
								onChange={(IsOn) =>
									handleActivateParameter({
										ParameterID: parameter.ParameterID,
										IsOn: Number(IsOn),
										UpdatedValue: Boolean(Number(IsOn)),
									})
								}
								disabled={!hasParametersWrite}
								checked={IsOn}
								size={'small'}
							></Switch>
						)}
					</StackItem>
				)}
				<StackItem isGrow className="setting-info-block">
					<Stack isVertical className="setting-info">
						<Title level={5}>{ParameterTitle}</Title>
						<Text>{ParameterDescription}</Text>
					</Stack>
				</StackItem>
			</Stack>

			{ParameterFormat !== 'Bit' && (
				<StackItem className="setting-block-rt">
					<Validation {...queries.isValidParamValue(paramValue)}>
						<NumberInput
							align="right"
							minValue={0}
							maxValue={parameter.ParameterFormat === 'Percentage' ? 100 : undefined}
							value={formatForUI(
								parameter.Detail_Value || parameter.Default_Value,
								parameter.ParameterFormat
							)}
							suffix={parameter.ParameterFormat === 'Percentage' ? '%' : null}
							isEnabled={hasParametersWrite}
							onChange={(uiValue) => {
								const backendValue = parseFromUI(uiValue, parameter.ParameterFormat);

								if (backendValue >= 0) {
									updateParamValue(backendValue);
									handleActivateParameter(
										{
											UpdatedValue: backendValue,
											ParameterID: parameter.ParameterID,
										},
										true
									);
								} else {
									updateParamValue(backendValue);
								}
							}}
						/>
					</Validation>
				</StackItem>
			)}

			{/* {Boolean(IsOn || parameter.IsLocked) && ParameterFormat === 'Bit' && (
				<StackItem>
					{
						<Checkbox
							checked={parameter.Detail_Value}
							onChange={e =>
								handleActivateParameter(
									{
										UpdatedValue: e.target.checked,
										ParameterID: parameter.ParameterID
									},
									true
								)
							}
						></Checkbox>
					}
				</StackItem>
			)} */}
		</Stack>
	);
};

export default ParameterDetailItem;
